import React from 'react';
import { Box } from '@mui/material';
import { useOcrInputStore } from '../store/ocrInputStore';
import { LeftPanel } from './LeftPanel';
import { RightPanel } from './RightPanel';
import { ResizablePanels } from '../../../core-components/theme/components/ResizablePanels';

interface DataInputResultsViewProps {
  onRetake: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DataInputResultsView: React.FC<DataInputResultsViewProps> = ({ onRetake }) => {
  const { extractedData, processedImageUrl, originalImageUrl } = useOcrInputStore();
  
  if (!extractedData || !processedImageUrl || !originalImageUrl) {
    return null;
  }

  return (
    <Box sx={{ flex: 1, minHeight: 0 }}>
      <ResizablePanels
        primary={<LeftPanel originalImageUrl={originalImageUrl} processedImageUrl={processedImageUrl} onRetake={onRetake} />}
        secondary={<RightPanel />}
        direction="horizontal"
        layoutKey="ocrInputSplit"
      />
    </Box>
  );
};